import { observer } from "mobx-react";
import { InputSwitch } from "primereact/inputswitch";
import { DeviceTypeCategory } from "../../../../api/firebase/types/device.types";
import { Scenario } from "../../../../api/firebase/types/scenario.types";
import ScenarioStore from "../../../../store/ScenarioStore";

enum ScenarioCapacity {
  HARDWARE_DEVICE = 1,
  DESKTOP_CLIENT = 10,
}

type ScenarioSelectionProps = {
  selectedScenarios: Set<string>;
  setSelectedScenarios: (scenarioIds: Set<string>) => void;
  deviceType: DeviceTypeCategory;
};

const ScenarioSelection: React.FC<ScenarioSelectionProps> = ({
  selectedScenarios,
  setSelectedScenarios,
  deviceType,
}) => {
  function ScenarioSwitch({ scenario }: { scenario: Scenario }) {
    const onChange = (isChecked: boolean) => {
      let updatedScenarios = new Set(selectedScenarios);
      if (isChecked) updatedScenarios.add(scenario.id);
      else updatedScenarios.delete(scenario.id);
      setSelectedScenarios(updatedScenarios);
    };

    return (
      <div
        className="p-d-flex p-ai-center p-ml-2 p-col-12 p-p-0"
        style={{ width: "100%" }}
      >
        <span className="p-col-6 p-my-0">{scenario.title}</span>
        <div className="p-col-3 p-p-0">
          <InputSwitch
            disabled={
              selectedScenarios.size >= ScenarioCapacity[deviceType] &&
              !selectedScenarios.has(scenario.id)
            }
            checked={selectedScenarios.has(scenario.id)}
            onChange={(e) => onChange(e.value)}
          />
        </div>
      </div>
    );
  }

  const { scenarios } = ScenarioStore;
  return (
    <div className="p-grid">
      {scenarios.map((scenario) => (
        <ScenarioSwitch key={scenario.id.substring(0, 8)} scenario={scenario} />
      ))}
    </div>
  );
};

export default observer(ScenarioSelection);
